import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BOOKING_URL } from "@/lib/site";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, light = false }) => (
  <p
    className={`text-sm tracking-[0.3em] uppercase font-medium mb-6 ${
      light ? "text-beige/80" : "text-ink-soft/70"
    }`}
  >
    {children}
  </p>
);

export const BookButton = ({ dark = false, testId, label = "Book time", className = "" }) => (
  <a
    data-testid={testId}
    href={BOOKING_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={`group inline-flex items-center gap-3 rounded-full px-8 py-3.5 text-sm tracking-[0.15em] uppercase font-medium transition-colors duration-300 ${
      dark
        ? "bg-olive text-sand hover:bg-olive-deep"
        : "bg-beige text-ink hover:bg-beige-deep"
    } ${className}`}
  >
    {label}
    <ArrowUpRight
      size={16}
      className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
    />
  </a>
);
